/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import * as msal from "@azure/msal-browser";
import { Configuration, LogLevel } from "@azure/msal-browser";
// import config from '../intConfig.json';

var access_token: string = "";
var expiry_date: Date = new Date();

export const getAccessToken = (accessToken?: string): string => {
    if(accessToken){
        access_token = accessToken;
    }

    return access_token
}

export const getTokenExpiry = (expiryDate?: Date): Date => {
    if(expiryDate){
        expiry_date = expiryDate;
    }

    return expiry_date
}



/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig:Configuration = {
    auth: {
        clientId: process.env.REACT_APP_PORTAL_CLIENT_ID? process.env.REACT_APP_PORTAL_CLIENT_ID : "",
        authority: process.env.REACT_APP_PORTAL_AUTHORITY? process.env.REACT_APP_PORTAL_AUTHORITY : "", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
        redirectUri: process.env.REACT_APP_PORTAL_REDIRECT_URI? process.env.REACT_APP_PORTAL_REDIRECT_URI : "",
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level: any, message: any, containsPii: any) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }	
            }	
        }	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: [process.env.REACT_APP_PORTAL_APP_SCOPES? process.env.REACT_APP_PORTAL_APP_SCOPES: ""],
};

export const apiRequest = {
    scopes: [process.env.REACT_APP_PORTAL_APP_SCOPES? process.env.REACT_APP_PORTAL_APP_SCOPES: ""],
};
/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me" //e.g. https://graph.microsoft.com/v1.0/me
};


export const msalInstance = new msal.PublicClientApplication(msalConfig);
